import React, { Component } from 'react'
import { SvgIcon } from '@mui/material';
import { observer } from 'mobx-react';
import { IPropsSvgIcone } from '../../modelo/Icone';

class IconeCertidao extends Component<IPropsSvgIcone> {
  render() {
    return (
      <SvgIcon {...this.props}>
        <path id="Selection"
        fill={this.props.htmlColor || 'currentColor'} 
        d="M 6.00,2.00
           C 6.00,2.00 6.00,6.00 6.00,6.00
             6.00,6.00 15.00,4.00 15.00,4.00
             15.00,4.00 15.00,8.00 15.00,8.00
             15.00,8.00 19.00,8.00 19.00,8.00
             19.00,8.00 19.00,20.00 19.00,20.00
             19.00,20.00 13.00,20.00 13.00,20.00
             13.00,20.00 13.00,22.00 13.00,22.00
             13.00,22.00 21.00,22.00 21.00,22.00
             21.00,17.83 22.20,5.37 18.69,3.02
             16.47,1.55 8.90,2.00 6.00,2.00 Z
           M 9.00,5.00
           C 9.00,5.00 9.00,7.00 9.00,7.00
             9.00,7.00 14.00,7.00 14.00,7.00
             14.00,7.00 14.00,5.00 14.00,5.00
             14.00,5.00 9.00,5.00 9.00,5.00 Z
           M 3.82,22.00
           C 3.82,22.00 7.00,20.00 7.00,20.00
             7.00,20.00 11.18,22.00 11.18,22.00
             11.05,19.52 12.01,12.82 11.18,11.15
             9.97,7.52 5.03,7.52 3.82,11.15
             2.99,12.82 3.95,19.52 3.82,22.00 Z
           M 7.18,10.91
           C 10.51,11.79 8.94,13.87 7.82,14.09
             6.69,14.32 4.45,12.99 7.18,10.91 Z
           M 14.00,11.00
           C 14.00,11.00 14.00,13.00 14.00,13.00
             14.00,13.00 18.00,13.00 18.00,13.00
             18.00,13.00 18.00,11.00 18.00,11.00
             18.00,11.00 14.00,11.00 14.00,11.00 Z
           M 14.00,14.00
           C 14.00,14.00 14.00,16.00 14.00,16.00
             14.00,16.00 18.00,16.00 18.00,16.00
             18.00,16.00 18.00,14.00 18.00,14.00
             18.00,14.00 14.00,14.00 14.00,14.00 Z
           M 9.00,19.00
           C 9.00,19.00 6.00,19.00 6.00,19.00
             7.47,17.33 7.53,17.33 9.00,19.00 Z
           M 13.00,17.00
           C 13.00,17.00 13.00,19.00 13.00,19.00
             13.00,19.00 18.00,19.00 18.00,19.00
             18.00,19.00 18.00,17.00 18.00,17.00
             18.00,17.00 13.00,17.00 13.00,17.00 Z" />
    </SvgIcon>
    )
  }
}

export default observer(IconeCertidao);
